import { render, staticRenderFns } from "./settingWorkExtraType.vue?vue&type=template&id=033d58f6&"
import script from "./settingWorkExtraType.vue?vue&type=script&lang=js&"
export * from "./settingWorkExtraType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports